import React from 'react';
import styled from 'styled-components';
import { SlideContainer } from './container';
import { SlideContent } from './content';
import { Text } from './text';
import { SlideProps } from '../Recap';

const SlideNoRecap = ({ current, scale }: SlideProps) => {
    return (
        <SlideContainer>
            <SlideContent bg="#e31a37" scale={scale}>
                <Text fontFamily="maison-neue" fontSize="22px" style={{textAlign: 'center', lineHeight: '1.2', marginBottom: '20px'}}>
                    Este año no nos visitaste lo suficiente para poder generar <strong>tu resumen del año</strong> 😞
                </Text>
                <Text fontFamily="maison-neue" fontSize="20px" style={{textAlign: 'center', lineHeight: '1.2'}}>
                    ¡Pero te esperamos en 2026 para que vivas <strong>experiencias y películas inolvidables</strong> en nuestras salas!
                </Text>
            </SlideContent>
        </SlideContainer>
    );
}

export default SlideNoRecap;